import { imageSource } from "@app/constants";
import { Box } from "@mui/material";

const SideIllustration = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        width: "100%",
        overflow: "hidden",
        display: { xs: "none", md: "block" },
      }}
    >
      <img
        src={imageSource.authSideBar}
        alt="logo"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    </Box>
  );
};

export { SideIllustration };
